/**
 * Tool descriptions and system prompts for codebase search
 */

export const CODEBASE_SEARCH_DESCRIPTION = `Semantic search that finds code by meaning, not exact text.

Use this to explore unfamiliar codebases or ask "how/where/what" questions:
- "How does X work?" - Find implementation details
- "Where is Y handled?" - Locate specific functionality
- "What happens when Z?" - Understand flow

The tool uses two-stage retrieval (embedding similarity + reranking) to find the most semantically relevant code chunks.

Returns code chunks with file paths, line ranges, and full content ranked by relevance.`;

export const CODEBASE_SEARCH_SYSTEM_PROMPT = `You have access to the codebase_search tool that performs semantic code search.

When searching:
- Use natural language queries describing what you're looking for
- Be specific about functionality, not variable names
- Use target_directories to narrow search if you know the area
- Results are ranked by relevance (rerank score is most important)

The tool returns:
- File paths with symbol names (e.g. "src/auth.ts::AuthService@L1-L17")
- Line ranges for precise navigation
- Full code content for each match
- Dual relevance scores: embedding similarity + rerank score

Use results to understand code or answer questions. The content is provided in full - avoid re-reading unless you need more context.`;

